module.exports = __webpack_public_path__ + "index.html"


/*****************
 ** WEBPACK FOOTER
 ** ./index.html
 ** module id = 185
 ** module chunks = 1
 **/